export default {
  ...window.Config,
  env: {
    isProduction: process.env.NODE_ENV !== 'production',
  },
}
